import styled from "styled-components";

export const HomeMainCatsCont = styled.section`
  ${({ theme: { isMobile } }) =>
    isMobile &&
    `
  .mainCatsListWrapper {
    transition: height 0.3s ease-in-out;
  }
  .setHeight{height:360px}
  `}
  .mainCatsListWrapper a {
    width: ${({ theme: { isDesktop } }) => (isDesktop ? "11.77%" : "29.1%")};
  }

  .homeCatImg {
    ${({ theme: { isMobile } }) =>
      isMobile
        ? `
            width: 67px;
            height: 67px;
          `
        : `
            width: 80px;
            height: 80px;
          `}
  }

  .mainCatsListWrapper div span {
    right: 0;
    left: 50%;
    transform: translateX(-50%);
    ${({ theme: { isMobile } }) =>
      isMobile
        ? `
            top: -16px;
            padding: 2px 4px;
          
          `
        : `
            top: -14px;
            padding: 2px 8px;
          `}
  }

  .mainCatsListWrapper > div,
  .mainCatsListWrapper button {
    border-radius: 50px;
  }

  .mainCatsListWrapper > .beforeExpand {
    left: 50%;
    bottom: 50px;
    transform: translateX(-50%) translateY(100%);
    z-index: 2;
  }

  .mainCatsListWrapper > .afterExpand {
    flex-basis: 100%;
  }

  .mainCatsListWrapper button {
    box-shadow: 0 0 16px 0 #00000033;
    padding: 13px 20px;
  }

  .mainCatsListWrapper .bounceEffect {
    animation: bounce 2s ease infinite;
    transform-origin: bottom;
    @keyframes bounce {
      0% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-10px);
      }
      100% {
        transform: translateY(0);
      }
    }
  }
`;
